/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownLeftIcon20Solid = forwardRef('ArrowADownLeftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.518 14.25H14.5a1.25 1.25 0 1 1 0 2.5H6A2.75 2.75 0 0 1 3.25 14V5.5a1.25 1.25 0 1 1 2.5 0v6.982l9.366-9.366a1.25 1.25 0 0 1 1.768 1.768L7.518 14.25Z" })));
});
